import { offerPlacementSummarySchema } from "@redotech/order-tracking-common/offer-network/offer-placement";
import * as z from "zod";

export const updateOfferPlacement = {
  name: "updateOfferPlacement" as const,
  input: z.object({ placementId: z.string().min(1), isLiveMode: z.boolean() }),
  output: z.object({ placement: offerPlacementSummarySchema }),
};
